import { Address } from "../models/address";

export class LegalAdAuctionDTO{

    public auctionId!:number;
    public void:boolean = false;
    public voidAt?:Date;
    public voidByUser?:string;
    public voidReason?:string;
    public auctionIsLive:boolean = false;
    public auctionType?:number;
    public auctionStatus?:number;
    public scheduleSeqNo?:number;
    public auctionStarting?:Date;
    public auctionEnding?:Date;
    public propertyId!:number;
    public propertyHeader?:string;
    public propertyAddress?:Address;
    public fileNo?:string;
    public caseNo?:string;
    public clientFileNo?:string;
    public attorneyFileNo?:string;
    public imageReference?:string;

    constructor(){
    }
}